import React, { useEffect, useCallback } from 'react'
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';

//icons
import InventoryIcon from '@mui/icons-material/Inventory';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';

import { columns, columnsStations } from './columns';
import { ItemForm } from './itemForm/ItemForm';

//component
import Snackbar from 'components/Snackbar/Snackbar';
import { ModalV2 } from 'components/Modal/ModalV2';
import RegularButton from 'components/CustomButtons/Button.js';
import CardTable from 'components/CardTable/CardTable.jsx';
import { LoadingComponent } from "components/Loading/LoadingComponent";

import { useForm } from 'hooks/useForm.js';
import { useToggle } from 'hooks/useToggle';

//redux
import { useDispatch, useSelector } from 'react-redux';
import { setSnackbar, clearSnackbar } from 'redux/actions/search/searchActions';
import {
  getItems,
  createNewItem,
  cleanItem,
  closeModal,
  closeEdit,
  resetItemSnackbar,
  configFilterItems,
  configSortedItems,
  configPageItems,
  configPageItemsSize,
  configPageItemStations,
  configPageItemStationsSize,
  configFilterItemStations,
  configSortedItemStations,
  openFormToUpdate,
} from 'redux/actions/integrations/itemsActions';
import { getCategories } from 'redux/actions/categories/categoriesActions';
import { getClasses } from 'redux/actions/classes/classesActions';
import { getCompaniesForItems } from 'redux/actions/companies/companiesForItemsAction';


// material-ui
import TextField from '@mui/material/TextField';
import Alert from '@mui/material/Alert';



export const ItemsTable = () => {
  const dispatch = useDispatch()
  const { isOpen, message, color, isLoading } = useSelector(({ search }) => search)
  const { items, stations, modal, item, loadingItems, modalEdit, snackbar, config, configStations, updateItems, search } = useSelector(({ items }) => items)
  const { filtered, page, pageSize, sorted } = config;
  const { filtered:filteredStations, page:pageStations, pageSize: pageSizeStations, sorted: sortedStations } = configStations;
  const { color: colorItem, message: messageItem, isOpen: isOpenItem } = snackbar;
  const { inputValues, handleInputOnChange } = useForm({
    searchItems: search
  })
  const [open, setOpen] = useToggle()
  const { searchItems } = inputValues

  //Config to item table
  const handleFilter = useCallback((e) => {
    dispatch(configFilterItems(e));
  }, []);

  const handleSort = useCallback((e) => {
    dispatch(configSortedItems(e))
  }, [])

  const handlePageItems = useCallback((e) => {
    dispatch(configPageItems(e))
  }, [])

  const handlePageSize = useCallback((e) => {
    dispatch(configPageItemsSize(e))
  }, [])

  // config to Station table
  const handleFilterStations = useCallback((e) => {
    dispatch(configFilterItemStations(e));
  }, []);

  const handleSortStations = useCallback((e) => {
    dispatch(configSortedItemStations(e))
  }, [])

  const handlePageItemsStations = useCallback((e) => {
    dispatch(configPageItemStations(e))
  }, [])

  const handlePageSizeStations = useCallback((e) => {
    dispatch(configPageItemStationsSize(e))
  }, [])

  const handleSearch = (e) => {
    e.preventDefault()
    if (searchItems.length === 0) {
      dispatch(setSnackbar('Por favor introduce una descripción del artículo', 'warning'))
      return
    }
    if (searchItems.length < 2 || searchItems.length > 250) {
      dispatch(setSnackbar('El artículo debe de tener una logitud minima de 2 caracteres', 'warning'))
      return
    }
    dispatch(getItems(searchItems))
  }

  const handleCloseSnackbar = () => {
    dispatch(clearSnackbar())
  }

  const handleCloseSnackbarItem = () => {
    dispatch(resetItemSnackbar())
  }

  const handleNewItem = () => {
    dispatch(createNewItem());
    setOpen();
  }
  const handleCloseNewItem = () => {
    dispatch(closeEdit());
    setOpen();
  }

  const handleCloseModal = () => {
    dispatch(closeModal())
  }

  const handleOpenModalToUpdate = () => {
    dispatch(openFormToUpdate())
  }

  useEffect(() => {
    dispatch(cleanItem());
    dispatch(getCategories());
    dispatch(getClasses());
    dispatch(getCompaniesForItems());
  }, [])

  useEffect(() => {
    modalEdit && setOpen();
  }, [modalEdit])

  return (
    <>
      <Alert style={{ marginTop: "1rem" }} severity="info">Usa este buscador para comprobar si existe en la organización maestra el artículo que desea dar de alta
        (NOTA: Esto podría demorar de 10 a 30 segundos).
        Si existe, solicita Compartir; si no, solicita Alta.
      </Alert>
      <CardTable
        columns={columns}
        data={items}
        isLoading={isLoading}
        hasControl
        hasHeader
        icon={<InventoryIcon />}
        title={`Busqueda de ${searchItems}`}
        titleBlock
        blockBtn
        filtered={filtered}
        page={page}
        sorted={sorted}
        pageSize={pageSize}
        onFilteredChange={handleFilter}
        onPageChange={handlePageItems}
        onSortedChange={handleSort}
        onPageSizeChange={handlePageSize}
        controls={
          <>
            <form onSubmit={handleSearch}>
              <TextField name="searchItems" value={searchItems} onChange={handleInputOnChange} variant="outlined" size="small"
                InputProps={{
                  endAdornment: <SearchIcon onClick={handleSearch}
                    style={{ cursor: 'pointer' }}
                  />,
                }}
                autoFocus={true}
              />

            </form>
            { Object.keys(updateItems).length > 0 &&
            <RegularButton
              justIcon
              round
              color="info"
              size="sm"
              tooltip="Artículos Guardados"
              onClick={handleOpenModalToUpdate}
            >
              {Object.keys(updateItems).length}
            </RegularButton>
            }
            <RegularButton
              justIcon
              round
              color="info"
              size="sm"
              tooltip="Nuevo Artículo"
              onClick={handleNewItem}
            >
              <AddIcon style={{ margin: 0 }} />
            </RegularButton>
          </>
        }

      />
      <Snackbar
        open={isOpen}
        place="tr"
        message={message}
        color={color}
        closeNotification={handleCloseSnackbar}
        close
      />
      <Snackbar
        open={isOpenItem}
        place="tr"
        message={messageItem}
        color={colorItem}
        closeNotification={handleCloseSnackbarItem}
        close
      />
      <ModalV2
        open={open}
        title={modalEdit ? 'Actualizar Artículo' : "Agregar nuevo artículo"}
        toRight
        onClose={handleCloseNewItem}
        isLoading={loadingItems}
      >
        <ItemForm onClose={handleCloseNewItem} />
      </ModalV2>
      <ModalV2
        open={modal}
        title={item?.itemDescription}
        onClose={handleCloseModal}
      >
        {loadingItems ? <LoadingComponent /> :
          <CardTable
            columns={columnsStations}
            data={stations}
            isLoading={loadingItems}
            icon={<InventoryIcon />}
            titleBlock
            filtered={filteredStations}
            page={pageStations}
            sorted={sortedStations}
            pageSize={pageSizeStations}
            onFilteredChange={handleFilterStations}
            onPageChange={handlePageItemsStations}
            onSortedChange={handleSortStations}
            onPageSizeChange={handlePageSizeStations}
          />
        }
      </ModalV2>
    </>
  )
}
